export default "__VITE_ASSET__f55a7b47__"